import { SETTINGS_TABS } from "../constants/settingsTabs";
import { useAuthStore } from "../../../store/authStore";

export default function SettingsTabs({ activeTab, onChange }) {
  const user = useAuthStore((state) => state.user);
  const userRole = user?.role;

  const filteredTabs = SETTINGS_TABS.filter((tab) => {
    if (!tab.roles) return true;
    return tab.roles.includes(userRole);
  });

  return (
    <div className="flex overflow-x-auto no-scrollbar scroll-smooth shrink-0">
      {filteredTabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`px-5 py-4 text-[13px] font-semibold transition-all whitespace-nowrap shrink-0 border-b-2 ${
            activeTab === tab.id
              ? "border-[#C91D25] text-[#C91D25]"
              : "border-transparent text-[#626262] hover:text-[#1A1A1A] hover:border-slate-300"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}




